/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export const DOC_TYPES_ALLOWED = {
  ALL: 'ALL',
  DEFINED_IN_CREATION: 'DEFINED_IN_CREATION',
  DEFINED_ON_FOLDER: 'DEFINED_ON_FOLDER'
} as const

export type DocTypesAllowedType = (typeof DOC_TYPES_ALLOWED)[keyof typeof DOC_TYPES_ALLOWED]
